
'use client'

import React from 'react'
import Header from '../home/Header'
import Footer from '../home/Footer'
import { ChevronLeft, ChevronRight, Mail, MapPin, Phone } from 'lucide-react'



const ContactUs = () => {


  return (
    
      <div className="pt-12 px-4 bg-white mt-20 mb-32">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our team is here to help you.</h2>
            <p className="text-xl text-gray-600">Get in touch with us for any questions or concerns.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="md:col-span-2">
              <a
                href="https://maps.app.goo.gl/vkuXiSKpzC1JgVWd7"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block h-full w-full"
              >
                <div className="flex items-start gap-6 p-6 bg-gray-50 rounded-lg transition-all duration-300 hover:shadow-md hover:bg-white h-full">
                  <div className="bg-[#ebf2f0] p-4 rounded-full shrink-0">
                    <MapPin className="w-6 h-6 text-green-600" />
                  </div>
                  <div className="text-left">
                    <h3 className="font-semibold text-xl mb-2 text-gray-900">Our Address</h3>
                    <p className="text-gray-700 mb-1">1st Floor, SSR Arcade, Plot no: 328, Road No. 1/2, Mathrusree Nagar, Hafeezpet, Miyapur, Hyderabad, Telangana 500049</p>
                  </div>
                </div>
              </a>
            </div>
            <a
              href='tel:+91 80724 88052'
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block h-full"
            >
              <div className="flex items-start gap-6 p-6 bg-gray-50 rounded-lg transition-all duration-300 hover:shadow-md hover:bg-white h-full">
                <div className="bg-[#ebf2f0] p-4 rounded-full shrink-0">
                  <Phone className="w-6 h-6 text-green-600" />
                </div>
                <div className="text-left">
                  <h3 className="font-semibold text-xl mb-2 text-gray-900">Contact Info</h3>
                  <p className="text-gray-700 mb-1">+91 80724 88052</p>
                  {/* <p className="text-gray-500 text-sm">+91 80724 88052</p> */}
                </div>
              </div>
            </a>
            <a
              href="mailto:sales@farminsta.com"
              className="inline-block h-full"
            >
              <div className="flex items-start gap-6 p-6 bg-gray-50 rounded-lg transition-all duration-300 hover:shadow-md hover:bg-white h-full">
                <div className="bg-[#ebf2f0] p-4 rounded-full shrink-0">
                  <Mail className="w-6 h-6 text-green-600" />
                </div>
                <div className="text-left">
                  <h3 className="font-semibold text-xl mb-2 text-gray-900">Email Us</h3>
                  <p className="text-gray-700 mb-1">sales@farminsta.com</p>
                  {/* <p className="text-gray-500 text-sm">contact@farminsta.com</p> */}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    
  )
}



const page = () => {
  return (
    <div>
      <Header currentPage="contact-us" />
      <ContactUs />
      <Footer />
    </div>
  )
}

export default page